export default class WSName {
	constructor({
		firstName,
		lastName,
		middleInitial = null,
		title = null,
		nameSuffix = null,
	}) {
		this.firstName = firstName;
		this.lastName = lastName;
		this.middleInitial = middleInitial;
		this.title = title;
		this.nameSuffix = nameSuffix;
	}

	toBackoffice() {
		return {
			firstName: this.firstName,
			lastName: this.lastName,
			middleInitial: this.middleInitial,
			title: this.title,
			nameSuffix: this.nameSuffix,
		};
	}

	static fromBackoffice(data) {
		const result = new WSName(data);
		return result;
	}

	static fromSerialized(data) {
		if (!data) {
			return null;
		}

		const result = new WSName(data);
		return result;
	}

	toResolver() {
		const forGraphql = Object.freeze(this);
		return forGraphql;
	}
}

export const WSNameType = [ `
	type WSName {
		firstName: String!
		lastName: String!
		middleInitial: String
		nameSuffix: String
		title: String
	}
` ];

export const InputWSNameType = [ `
	input InputWSName {
		firstName: String!
		lastName: String!
		middleInitial: String
		nameSuffix: String
		title: String
	}
` ];
